import { useEffect } from 'react';

import { useUnsavedChangesStore } from '@/store/unsavedChangesStore';

interface UnsavedChangesGuardOptions {
    title?: string;
    text?: string;
}

export const useUnsavedChangesGuard = (
    hasUnsavedChanges: boolean,
    key: string,
    options?: UnsavedChangesGuardOptions
) => {
    const setHasUnsavedForKey = useUnsavedChangesStore((s) => s._setHasUnsavedForKey);

    useEffect(() => {
        setHasUnsavedForKey(key, hasUnsavedChanges, options);
        return () => setHasUnsavedForKey(key, false);
    }, [key, hasUnsavedChanges, options, setHasUnsavedForKey]);
};
